<template>
    <div class="registration-control" @click="isRegistration">
        <svg class="registration-control__icon">
            <use xlink:href="#svg-user"></use>
        </svg>
        <span
            class="registration-control__text"
            v-if="!result.authInfo.isAuthorized"
        >
            {{ result.messages.login_cabinet }}
        </span>
        <span
            v-else
            class="registration-control__profile"
        >
            <span class="registration-control__name">
                {{ result.authInfo.user_name }}
            </span>
        </span>
        <a
            v-if="result.authInfo.isAuthorized"
            href="?logout=yes"
            class="registration-control__log-out"
            @click.prevent.stop="logOut"
        >
            {{ result.messages.exit }}
        </a>
    </div>
</template>
<script>
    import {mapState} from "vuex";

    export default {
        name: "registration-control",
        selector: '.registration-control',
        computed: {
            ...mapState({
                result: ({personal}) => personal.data,
            }),
        },
        methods: {
            isRegistration() {
              if (!this.result.authInfo.isAuthorized){

                    // close mobile menu
                  const menu = document.querySelector('.close-menu');
                    if (window.innerWidth <= 992 && menu) {
                        menu.click();
                    }

                  this.$DefModal.show({
                      name: 'enter-cabinet',
                      width: '440px',
                  });

              } else{
                  location.href = '/' + this.result.personalCabPath;
              }
          },
            logOut({ target }) {
                /**
                 * before log out clear session storage
                 */
                window.sessionStorage.removeItem('phoneValidityRejected');
                window.location.href = target.href;
            }
        },
        mounted() {
            // console.log(this.obData);
            // if (App.debug) console.log('Component: registration-control', this.result);
        },
        created() {
            if (this.$store) {
                this.$store.commit('personal/setData', this.result);
            }
        },

    }
</script>
<style lang="scss" scoped>
.registration-control{
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 10px 0 0 ;
    cursor: pointer;
    &__icon{
        display: block;
        width: 18px;
        height: 18px;
        flex-shrink: 0;
    }
    &__name, &__text{
        font-size: rem(14);
        margin-left: 10px;
        font-weight: 500;
    }
    &__log-out{
        display: flex;
        align-items: center;
        margin-left: 15px;
        font-weight: 500;
    }
}
</style>
